import { render, staticRenderFns } from "./divvy-edit.vue?vue&type=template&id=5637b503&scoped=true&"
import script from "./divvy-edit.vue?vue&type=script&lang=js&"
export * from "./divvy-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637b503",
  null
  
)

export default component.exports